import './error.css';

function ErrorPage({ message, onReset }) {
    return (
        <div className="error-page">
            <h2 className="error-page__title">Something went wrong</h2>
            {message && <p className="error-page__message">{message}</p>}
            {onReset && (
                <button className="error-page__btn" onClick={onReset}>
                    Try Again
                </button>
            )}
        </div>
    );
}

export default ErrorPage;
